import {
  FacebookIcon_default
} from "./chunk-WTTEYMQQ.mjs";
export {
  FacebookIcon_default as default
};
